import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastController } from '@ionic/angular/standalone';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip auth requests (they handle their own errors)
  if (req.headers.has('X-Skip-Interceptor')) {
    return next(req);
  }

  // Skip silent background requests (e.g. async article resolution)
  if (req.headers.has('X-Silent')) {
    return next(req.clone({ headers: req.headers.delete('X-Silent') }));
  }

  const toastCtrl = inject(ToastController);

  return next(req).pipe(
    catchError((error) => {
      let message = 'Une erreur est survenue.';

      if (error.status === 0) {
        message = 'Connexion impossible. Vérifiez votre réseau.';
      } else if (error.status === 400) {
        message = error.error?.message || error.error || message;
      } else if (error.status === 401) {
        message = 'Session expirée. Veuillez vous reconnecter.';
      } else if (error.status === 404) {
        message = error.error?.message || 'Ressource non trouvée.';
      }

      toastCtrl
        .create({
          message,
          duration: 3000,
          position: 'top',
          color: 'danger',
          icon: 'alert-circle-outline',
        })
        .then((toast) => toast.present());

      return throwError(() => error);
    })
  );
};
